import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import CancelBooking from "@/pages/CancelBooking";
import { Toaster } from "@/components/ui/sonner";
import { api, getToken, setToken } from "@/lib/api";
import "@/App.css";

function ProtectedAdmin({ children }) {
  const [state, setState] = useState({ checking: true, ok: false });
  useEffect(() => {
    const t = getToken();
    if (!t) {
      setState({ checking: false, ok: false });
      return;
    }
    axios.get(`${api}/auth/me`, { headers: { Authorization: `Bearer ${t}` } })
      .then(() => setState({ checking: false, ok: true }))
      .catch(() => { setToken(null); setState({ checking: false, ok: false }); });
  }, []);
  if (state.checking) return <div className="min-h-screen bg-ink text-zinc-500 flex items-center justify-center font-mono text-xs uppercase tracking-widest">Authenticating...</div>;
  if (!state.ok) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/cancel/:token" element={<CancelBooking />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<ProtectedAdmin><Admin /></ProtectedAdmin>} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default App;
